// dismissalValidation.js
export const dismissalValidation = {
  validateForm(data, files) {
    const errors = {};

    // Проверка номера наказа
    if (!data.orderNumber || data.orderNumber.trim() === '') {
      errors.orderNumber = 'Номер наказу обов\'язковий';
    }

    // Проверка даты наказа
    if (!data.orderDate) {
      errors.orderDate = 'Дата наказу обов\'язкова';
    } else {
      const orderDate = new Date(data.orderDate);
      if (isNaN(orderDate.getTime())) {
        errors.orderDate = 'Некоректна дата наказа';
      }
    }

    // Проверка причины выбытия
    if (!data.reason || data.reason.trim() === '') {
      errors.reason = 'Причина вибуття обов\'язкова';
    }

    // Проверка даты выбытия
    if (!data.dismissalDate) {
      errors.dismissalDate = 'Дата вибуття обов\'язкова';
    } else {
      const dismissalDate = new Date(data.dismissalDate);
      if (isNaN(dismissalDate.getTime())) {
        errors.dismissalDate = 'Некоректна дата вибуття';
      }
    }

    // Проверка файлов
    if (!files || files.length === 0) {
      errors.files = 'Скан-копія наказа обов\'язкова';
    }

    return {
      isValid: Object.keys(errors).length === 0,
      errors
    };
  },

  validateOrderNumber(value) {
    if (!value || value.trim() === '') {
      return 'Номер наказа обов\'язковий';
    }
    return '';
  },

  validateOrderDate(value) {
    if (!value) {
      return 'Дата наказа обов\'язкова';
    }
    const date = new Date(value);
    if (isNaN(date.getTime())) {
      return 'Некоректна дата наказа';
    }
    return '';
  },

  validateReason(value) {
    if (!value || value.trim() === '') {
      return 'Причина вибуття обов\'язкова';
    }
    return '';
  },

  validateDismissalDate(value) {
    if (!value) {
      return 'Дата вибуття обов\'язкова';
    }
    const date = new Date(value);
    if (isNaN(date.getTime())) {
      return 'Некоректна дата вибуття';
    }
    return '';
  },

  validateFiles(files) {
    if (!files || files.length === 0) {
      return 'Скан-копія наказа обов\'язкова';
    }
    return '';
  }
};